import { environment } from 'src/environments/environment';
import {Injectable} from "@angular/core";

@Injectable({ providedIn: 'root' })
export class AppConfigService {
    readonly apiBaseUrl = environment.apiBaseUrl;
    readonly imagesBaseUrl = environment.imagesBaseUrl;
    readonly isProduction = environment.production;
    readonly environmentName = environment.environmentName;
}